// src/components/HomepageSection1.js
import React, { useRef, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { trackClickEvent } from "../utils/analytics";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import mediaServicesImg from "../assets/images/multiturbine5Agradient.jpg";

gsap.registerPlugin(ScrollTrigger);

export default function HomepageSection1() {
  const sectionRef = useRef(null);
  const overlayRef = useRef(null);
  const contentRef = useRef(null);
  const navigate   = useNavigate();

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.fromTo(
        contentRef.current,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top center",
          },
        }
      );
      gsap.fromTo(
        overlayRef.current,
        { opacity: 0 },
        {
          opacity: 0.5,
          duration: 0.8,
          ease: "none",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top center",
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  const onClickDiscover = () => {
    trackClickEvent("Homepage Hero: Discover");
    navigate("/services");
  };

  return (
    <section
      ref={sectionRef}
      className="relative h-screen w-full overflow-hidden"
    >
      {/* background image */}
      <img
        src={mediaServicesImg}
        alt="Services Highlight"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* gentle dark overlay */}
      <div
        ref={overlayRef}
        className="absolute inset-0 bg-black/40 pointer-events-none"
      />

      {/* hero content */}
      <div
        ref={contentRef}
        className="relative z-10 flex flex-col justify-end h-full"
      >
        <div className="absolute left-8 bottom-10 md:bottom-24">
          <div className="relative pl-6 md:pl-8 max-w-xl text-white">
            {/* vertical line */}
            <div className="absolute left-0 top-0 h-full w-[2px] bg-white/30" />

            <h1 className="text-4xl md:text-6xl font-heading font-semibold">
              Services
            </h1>
            
            <p className="text-xl md:text-2xl font-body mt-2">
              Aviation photography + ferry services.
            </p>
            <p className="text-xl md:text-2xl font-body mt-2">
              Built by a pilot. Trusted by the pros.
            </p>

            <div
              onClick={onClickDiscover}
              className="mt-8 inline-flex items-center justify-between gap-3
                         px-8 py-4 h-20 rounded-full
                         bg-white/10 hover:bg-white/20
                         text-white font-body font-semibold tracking-tight
                         backdrop-blur-md transition duration-300
                         border border-white/30 text-lg cursor-pointer"
            >
              <span>Discover</span>
              <ArrowRight className="w-6 h-6 stroke-[1.5]" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
